import { useState } from 'react';

import { X } from '@phosphor-icons/react';
import classnames from 'classnames';

import type { MeteredPaywallUsageBannerProps } from './MeteredPaywallUsageBanner.types';

const substituteViewedPosts = (text: string | null | undefined, count: number): string | null | undefined => {
  if (text == null) return text;
  return text.replace(/\{\{viewed_posts\}\}/g, String(count));
};

export function MeteredPaywallUsageBanner({
  backgroundColor = '#ffffff',
  textColor = '#111827',
  buttonBackgroundColor = '#8b5cf6',
  buttonTextColor = '#ffffff',
  closeIconColor = '#6b7280',
  title,
  description,
  button_text,
  closeAriaLabel = 'Close',
  viewedCount,
  upgradePath = '/upgrade',
  premiumOfferId,
  onClose,
}: MeteredPaywallUsageBannerProps) {
  const upgradeParams = new URLSearchParams();
  if (premiumOfferId) upgradeParams.set('offer_id', premiumOfferId);
  const upgradeUrl = upgradeParams.size > 0 ? `${upgradePath}?${upgradeParams.toString()}` : upgradePath;
  const [isClosing, setIsClosing] = useState(false);

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => onClose?.(), 300);
  };

  const displayTitle = viewedCount != null ? substituteViewedPosts(title, viewedCount) : title;
  const displayDescription = viewedCount != null ? substituteViewedPosts(description, viewedCount) : description;

  return (
    <div
      id="metered-paywall-usage-banner"
      className={classnames(
        'fixed bottom-0 left-0 right-0 z-40 flex items-center justify-center gap-6 px-10 py-6 border-t border-gray-200 box-border transition-transform duration-300',
        isClosing ? 'translate-y-full' : 'translate-y-0',
      )}
      style={{ backgroundColor }}
    >
      <div className="flex flex-col gap-0.5">
        <p className="m-0 text-sm font-semibold" style={{ color: textColor }}>
          {displayTitle}
        </p>
        <p className="m-0 text-[13px] opacity-70" style={{ color: textColor }}>
          {displayDescription}
        </p>
      </div>

      <a
        href={upgradeUrl}
        className="border-none rounded-md px-5 py-2.5 text-sm font-semibold cursor-pointer whitespace-nowrap shrink-0 no-underline"
        style={{ backgroundColor: buttonBackgroundColor, color: buttonTextColor }}
      >
        {button_text}
      </a>

      <button
        type="button"
        aria-label={closeAriaLabel}
        onClick={handleClose}
        className="absolute top-[15px] right-4 bg-transparent border-none cursor-pointer p-1 flex items-center justify-center"
        style={{ color: closeIconColor }}
      >
        <X size={16} />
      </button>
    </div>
  );
}
